import React, { useState } from "react";

import closeMenuIcon from "../img/close_menu_white.svg";

export default function ImageOverlay({ fullImage, closeImageOverlay }) {
  const [loaded, setLoaded] = useState(false);

  function handleClose() {
    setLoaded(false);
    closeImageOverlay();
  }
  setInterval(() => {
    setLoaded(true);
  }, 100);

  const cls = loaded ? "imgviewer" : "imgviewer hidden";
  return (
    <div className="overlay overlayimgviewer">
      <div className="overlaybg imgbgviewer" onClick={handleClose}></div>
      <div className="overlayHolderImg" onClick={handleClose}>
        <div className="mouse imgviewerclose" onClick={handleClose}>
          Lukk <img src={closeMenuIcon} alt="" className="ml1 menu_icon" />
        </div>

        <div
          className={cls}
          style={{ backgroundImage: `url(${fullImage})` }}
        ></div>
      </div>
    </div>
  );
}
